function createStorageProxy (storageType, namespace) {
  return {
    setItem: (key, value) => {
      return storageType.setItem(`${namespace}-${key}`, value);
    },
    getItem: (key) => {
      return storageType.getItem(`${namespace}-${key}`);
    },
    removeItem: (key) => {
      return storageType.removeItem(`${namespace}-${key}`);
    },
    clear: () => {
      Object.keys(storageType).forEach((key) => {
        if (key.startsWith(namespace)) {
          storageType.removeItem(key);
        }
      });
    }
  };
}

const storageKey = 'jsq_p';
window.sessionStorageProxy = createStorageProxy(window.sessionStorage, storageKey);
window.localStorageProxy = createStorageProxy(window.localStorage, storageKey);




// WEBPACK FOOTER //
// ./src/lib/storage.js